import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPlacingMoneySource, selectAvailableMoneySources } from '../../../../../selectors/publishTerms';
import { selectIsSubagent } from '../../../../../selectors/user';
import { setPlacingMoneySource } from '../../../../../actions/publishTerms';
import { loadPublishTerms } from '../../../../../thunks/publishTerms/loadPublishTerms';
import { EMoneySource } from '../../../../../types/reducers/user';

import { getSources } from './utils';

export const useMoneySourceTabsContainer = () => {
  const dispatch = useDispatch();
  const availableMoneySources = useSelector(selectAvailableMoneySources);
  const moneySource = useSelector(selectPlacingMoneySource);

  const isRender = useSelector(selectIsSubagent);

  const handleChange = useCallback(
    (value: EMoneySource) => {
      dispatch(setPlacingMoneySource(value));
      dispatch(loadPublishTerms());
    },
    [dispatch],
  );

  const sources = getSources(availableMoneySources, moneySource, handleChange);

  return { isRender, sources };
};
